const switches = {
    elasticAnimation : false,
    halfItemOverlap : false,
    dropHighlight : false,
    extendEmptyMessage: false,
    resizeGhosts: false
};

export default switches;